import { render, staticRenderFns } from "./sb-staking.vue?vue&type=template&id=586151c1&scoped=true&"
import script from "./sb-staking.vue?vue&type=script&lang=ts&"
export * from "./sb-staking.vue?vue&type=script&lang=ts&"
import style0 from "./sb-staking.vue?vue&type=style&index=0&id=586151c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586151c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow,VSpacer})
